module.exports = __webpack_public_path__ + "static/img/image_bg2.3a1b7285.jpg";